// extracted by mini-css-extract-plugin
export default {"root":"IconHotelAirConditioner_root__SVjvx"};